// ECB reference rates via Frankfurter (no key, no limit, updated ~16:00 CET on working days).
import { DISPLAY_CURRENCIES, type FxRates } from '@/types';
import { marketFetch } from './errors';

export async function fetchFxRates(extra: string[] = [], signal?: AbortSignal): Promise<FxRates> {
  const symbols = Array.from(new Set([...DISPLAY_CURRENCIES.filter((c) => c !== 'USD'), ...extra.map((c) => c.toUpperCase()).filter((c) => c !== 'USD')]));
  const url = `https://api.frankfurter.dev/v1/latest?base=USD&symbols=${symbols.join(',')}`;
  const json = (await (await marketFetch(url, { signal }, 'Frankfurter')).json()) as { date: string; rates: Record<string, number> };
  return { base: 'USD', date: json.date, rates: { ...json.rates, USD: 1 }, fetchedAt: Date.now() };
}
